const base = "/api"
const API = {
    "queryMenu" : base+"/home/query-boss-menu",
    "validUser" : base+"/home/valid-user",
    "login"     : base+"/home/login",
    "logout"    : base+"/home/logout",
}
export default API;